import { useRouter } from 'next/router'
import React from 'react'

import { Button, Row, Col, Container } from 'reactstrap'

import { ActivitiesApi, UsersApi, LoginApi } from 'typescript-axios'

import ReactHtmlParser from 'react-html-parser'
import { getAxiosParams } from '../../utils/client'

import WithLocale from '../../hocs/WithLocale'
import useTranslation from '../../hooks/UseTranslation'
import { translate } from '../../translations/utils'
import { UserContext } from '../../contexts/UserContext'
import GuruModal from '../../components/GuruModal'
import Signup from '../../components/Signup'

const LOGIN_SERVICE = new LoginApi(getAxiosParams())
const USER_SERVICE = new UsersApi(getAxiosParams())

const ACTIVITY_SERVICE = new ActivitiesApi(getAxiosParams())

export async function getStaticProps({ locale, defaultLocale }) {
  const activities =
    await ACTIVITY_SERVICE.readActivitiesApiV1ActivitiesGet().then(
      (res) => res.data
    )
  return {
    props: {
      nav: {
        light: true,
        classes: 'shadow',
        color: 'white'
      },
      title: translate('signup_title', locale, defaultLocale),
      activities,
      hideHeader: true,
      hideFooter: true,
      noPaddingTop: true,
      listingForm: true,
      locale,
      defaultLocale
    },
    revalidate: 1800
  }
}

const Page = (props) => {
  const router = useRouter()
  const { t } = useTranslation()
  const [redirectUrl, setRedirectUrl] = React.useState(router.query.redirectUrl)
  const [showModal, setShowModal] = React.useState(false)
  const [modalContent, setModalContent] = React.useState({})
  const [isGuru, setIsGuru] = React.useState(null)
  const [isDemo, setIsDemo] = React.useState(null)
  const [isGuruOrg, setIsGuruOrg] = React.useState(null)
  const { loggedUser } = React.useContext(UserContext)

  React.useEffect(() => {
    setRedirectUrl(router.query.redirectUrl)
  }, [router.query.redirectUrl])

  React.useEffect(() => {
    if (router.query.isGuru) {
      const isGuruOrg = parseInt(router.query.isGuru) === 1
      setIsGuru(isGuruOrg)
      setIsGuruOrg(isGuruOrg)
    }
    if (router.query.isDemo) {
      setIsDemo(isDemo)
    }
  }, [router.isReady])

  const redirect = (showHelp) => {
    const url =
      redirectUrl ||
      (loggedUser?.is_guru ? (showHelp ? '/onboard' : '/guru') : '/my-teachers')
    router.replace(url)
  }

  const redirectIfLoggedIn = (showHelp = true) => {
    if (loggedUser) {
      redirect(showHelp)
    }
  }

  React.useEffect(() => {
    redirectIfLoggedIn(false)
  }, [])

  const back = () => {
    isGuruOrg !== null ? router.back() : setIsGuru(null)
  }

  return (
    <>
      <GuruModal
        onClosed={redirectIfLoggedIn}
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        title={modalContent?.title}
      >
        {modalContent?.msg}
      </GuruModal>
      <section className='py-5 '>
        <Container>
          <Row>
            <Col lg='9' className='ml-auto mr-auto'>
              <div>
                <p className='subtitle text-primary'>{t('signup_subtitle')}</p>
                <h1 className='h2 mb-2'>
                  {t(
                    isGuru === null
                      ? 'signup_what_i_want_to_do'
                      : 'signup_title'
                  )}
                </h1>
                {isGuru === null ? (
                  <>
                    <Row className='pt-4'>
                      <Col lg='6' md='6' className='mb-2 mb-md-0'>
                        <Button
                          block
                          color='primary'
                          className='h-100'
                          onClick={() => setIsGuru(false)}
                        >
                          {t('signup_i_am_adept')}
                        </Button>
                      </Col>
                      <Col lg='6' md='6'>
                        <Button
                          block
                          color='negative-primary'
                          className='h-100'
                          onClick={() => setIsGuru(true)}
                        >
                          {t('signup_i_am_guru')}
                        </Button>
                      </Col>
                    </Row>
                    <Row className='form-block flex-column flex-sm-row'>
                      <Col className='text-center text-sm-left'>
                        <Button
                          onClick={() => router.back()}
                          color='link'
                          className='text-muted'
                        >
                          <i className='fa-chevron-left fa mr-2' />
                          {t('back')}
                        </Button>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <Signup
                    back={back}
                    activities={props.activities}
                    redirectUrl={redirectUrl}
                    onSuccess={(accountCreated = true) => {
                      if (accountCreated) {
                        // inform user that account was created
                        setModalContent({
                          title: t('account_created_title'),
                          msg: ReactHtmlParser(t('account_created_subtitle'))
                        })
                        setShowModal(true)
                      } else {
                        redirect(false)
                      }
                    }}
                    onFailure={(msg) => {
                      setModalContent({ title: t('modal_title_oops'), msg })
                      setShowModal(true)
                    }}
                    isDemo={isDemo}
                    isGuru={isGuru}
                  />
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default WithLocale(Page)
